import { SupplementaryAmountType } from '../enums/supplementary-amount-type';

export class SupplementaryAmountTypeLookup {
    static getLookup() {
        return [
            { label: 'Percentage', value: SupplementaryAmountType.Percentage },
            { label: 'Value', value: SupplementaryAmountType.Value }
        ];
    }

    static getTitle(value: number): string {
        switch (value) {
            case SupplementaryAmountType.Percentage:
                return 'Percentage';
            case SupplementaryAmountType.Value:
                return 'Value';
            default:
                return '';
        }
    }
}
